import { configureConsoleLoggersToForwardToGlobalLogger, globalLogConfiguration, globalLogContext } from "@octopusdeploy/logging";
import { configureSerilogIngestionSink } from "~/utils/logging/configureSerilogIngestion";
import { portalLoggingContextProvider } from "~/utils/logging/portalLoggingContext";
import { browserLoggingContextProvider, setupGlobalBrowserLogContext } from "./browserLoggingContext";
globalLogConfiguration.attachContextProvider(portalLoggingContextProvider);
globalLogConfiguration.attachContextProvider(browserLoggingContextProvider);
setupGlobalBrowserLogContext();
configureSerilogIngestionSink();
configureConsoleLoggersToForwardToGlobalLogger();
globalLogContext.setApplication("Octopus.Server.Portal");
